import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

import "./ProductPrice.scss"

/**
 * Product Details
 */
@Component
export class ProductPrice extends ThemeComponent {

}
